import { render, staticRenderFns } from "./GeneralTaskList.vue?vue&type=template&id=dc28468a"
import script from "./GeneralTaskList.vue?vue&type=script&lang=js"
export * from "./GeneralTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports